/**
 * `useFetch` wrapper that uses custom $fetch
 *
 * @see {@link useApi} - custom fetch provider
 */
export const useApiFetch: typeof useFetch = (reqT, opts) => {
  return useFetch(reqT, {
    ...opts,
    $fetch: useApi(),
  });
};

/**
 * Returns a $fetch wrapper that handles 401 responses with redirects to /login
 */
export function useApi(): typeof $fetch {
  const nuxtApp = useNuxtApp();
  const serverEvent = useRequestEvent(nuxtApp);
  // in the case of SSR, forward client's cookie header to API calls
  const headers = isServer() ? useRequestHeaders(["cookie"]) : undefined;

  const api = $fetch.create({
    headers,
    onRequest: (ctx) => {
      const path =
        typeof ctx.request === "string" ? ctx.request : ctx.request.url;
      if (!path.startsWith("/api/")) {
        throw new Error("useApi() must be used to call /api/ calls only");
      }
    },
    onResponse: useCookieForwardingOnResponse(serverEvent),
    onResponseError: useOnResponseError(serverEvent, nuxtApp),
  });
  return api;
}
